import { render, staticRenderFns } from "./form_contract.vue?vue&type=template&id=20e49232&"
import script from "./form_contract.vue?vue&type=script&lang=js&"
export * from "./form_contract.vue?vue&type=script&lang=js&"
import style0 from "./form_contract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e49232')) {
      api.createRecord('20e49232', component.options)
    } else {
      api.reload('20e49232', component.options)
    }
    module.hot.accept("./form_contract.vue?vue&type=template&id=20e49232&", function () {
      api.rerender('20e49232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_contract.vue"
export default component.exports